import script from "./BookingStore.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingStore.vue?vue&type=script&setup=true&lang=js"

import "./BookingStore.vue?vue&type=style&index=0&id=f1573fa4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1573fa4"]])

export default __exports__